import { memo } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import Animated, { type AnimatedStyle } from "react-native-reanimated";
import type { ViewStyle } from "react-native";
import { View } from "@src/components";
import { PressableScale } from "pressto";
import { Icon } from "@src/components/Icon";

type AnimatedFullscreenButtonProps = {
  isFullscreen: boolean;
  controlsVisible: boolean;
  animatedStyle: AnimatedStyle<ViewStyle>;
  onPress: () => void;
};

export const AnimatedFullscreenButton = memo(
  ({ isFullscreen, controlsVisible, animatedStyle, onPress }: AnimatedFullscreenButtonProps) => {
    const { theme } = useUnistyles();

    return (
      <Animated.View
        style={[styles.container, animatedStyle]}
        pointerEvents={controlsVisible || isFullscreen ? "auto" : "none"}
      >
        <PressableScale onPress={onPress} hitSlop={theme.spacing.md}>
          <View style={styles.button}>
            <Icon
              name={isFullscreen ? "fullscreenExit" : "fullscreen"}
              size={theme.spacing["5xl"]}
              color={theme.colors.mediaOverlay.foreground}
            />
          </View>
        </PressableScale>
      </Animated.View>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    position: "absolute",
    bottom: theme.spacing.lg,
    right: theme.spacing.lg,
    zIndex: 10000,
  },
  button: {
    width: theme.spacing["8xl"],
    height: theme.spacing["8xl"],
    borderRadius: theme.spacing["2xl"],
    backgroundColor: theme.colors.mediaOverlay.backgroundMedium,
    alignItems: "center",
    justifyContent: "center",
  },
}));
